import { latestSchemaVersion } from '../schema/flameSchema'
import { defineExample, tid, vid } from './util'

/**
 * Phoenix Nebula — fiery cosmic explosion with radiating wings.
 * exponential3D + spiral3D create outward-flowing flame structures,
 * julia3D adds complex folding, and heart3D brings wing-like symmetry.
 */
export const example35 = defineExample({
  version: latestSchemaVersion,
  metadata: {
    author: 'unknown',
    name: 'Phoenix Nebula',
    description:
      'fiery cosmic explosion with radiating wings. exponential3D + spiral3D create outward-flowing flame structures, julia3D adds complex folding, and heart3D brings wing-like symmetry.',
  },
  renderSettings: {
    dimensions: 3,
    exposure: -1.8,
    skipIters: 22,
    drawMode: 'light',
    colorInitMode: 'colorInitZero',
    pointInitMode: 'pointInitUnitBall',
    vibrancy: 1.4,
    contrast: 4.2,
    gamma: 3.2,
    depthColorPower: 0.0,
    lightDirection: [0, -0.8, -0.5],
    lightPower: 0.1,
    highlightPower: 1.1,
    densityEstimationQuality: 0.7,
    estimatorCurve: 0.4,
    paletteMode: 0,
    palettePhase: 0.15,
    paletteSpeed: 0.6,
    camera: { zoom: 1, position: [0, 0] },
    camera3D: {
      theta: 0.5,
      phi: 1.4,
      radius: 2.5,
      target: [0, 0, 0],
      fov: 55,
    },
  },
  transforms: {
    [tid('3d_phoenix_a')]: {
      probability: 0.4,
      preAffine: {
        a: 0.75,
        b: 0.15,
        c: 0,
        d: 0,
        e: -0.15,
        f: 0.75,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 0.85,
        l: 0,
      },
      postAffine: {
        a: 1,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 1,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 1,
        l: 0,
      },
      color: { x: 0.3, y: 0.5 },
      colorSpeed: 0.5,
      variations: {
        [vid('3d_phoenix_a_v0')]: { type: 'exponential3D', weight: 0.7 },
        [vid('3d_phoenix_a_v1')]: { type: 'spiral3D', weight: 0.5 },
      },
    },
    [tid('3d_phoenix_b')]: {
      probability: 0.35,
      preAffine: {
        a: 0.85,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 0.85,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 0.85,
        l: 0,
      },
      postAffine: {
        a: 1,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 1,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 1,
        l: 0,
      },
      color: { x: -0.1, y: 0.4 },
      colorSpeed: 0.4,
      variations: {
        [vid('3d_phoenix_b_v0')]: { type: 'julia3D', weight: 0.8 },
        [vid('3d_phoenix_b_v1')]: { type: 'heart3D', weight: 0.3 },
      },
    },
    [tid('3d_phoenix_c')]: {
      probability: 0.25,
      preAffine: {
        a: 0.6,
        b: 0,
        c: 0.1,
        d: 0,
        e: 0,
        f: 0.6,
        g: 0,
        h: 0.15,
        i: -0.1,
        j: 0,
        k: 0.6,
        l: 0,
      },
      postAffine: {
        a: 0,
        b: -1,
        c: 0,
        d: 0,
        e: 1,
        f: 0,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 1,
        l: 0,
      },
      color: { x: 0.6, y: -0.1 },
      colorSpeed: 0.35,
      variations: {
        [vid('3d_phoenix_c_v0')]: { type: 'swirl3D', weight: 0.6 },
        [vid('3d_phoenix_c_v1')]: { type: 'linear3D', weight: 0.4 },
      },
    },
  },
})
